<template>
  <div>
    <div class="modal__content-title">
      <span class="modal__item-title" v-html="item.title"></span>
      <div class="modal__item-details" v-if="item.description" v-html="item.description"></div>
    </div>
    <div class="grid modal__wo-meta-data">
      <div class="grid__col-no-gutter--4 h-no-padding">
        <People :item="item"></People>
        <FileAttachments :item="item"></FileAttachments>
      </div>
      <div class="grid__col--8">
        <div class="modal__item-row">
          <div class="grid modal__wo-note-container" v-if="item.note">
            <div class="grid__col--1 h-no-padding h-right-align">
              <i class="fas fa-sticky-note h-color-fuel-navy"></i>
            </div>
            <div class="grid__col--11 h-no-margin h-no-padding modal__wo-note" v-html="item.note"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import FileAttachments from './files/FileAttachments.vue';
  import People from './people/People.vue';

  export default {
    name: 'GenericItem',
    components: {
      FileAttachments,
      People,
    },
    props: ['item', 'index'],
    computed: {
      ...mapGetters('meetingAgendas', ['currentAgenda']),
    },
  };
</script>
